import Stage from './Stage.js';
import React from 'react';

export default class Colombo {
  constructor() {
    this.stages = 
    [
      // Colombo
      new Stage(
        [[79.7589, 7.0781], [80.1921, 6.7948]],
        (<div className="layout-timeline-info layout-floating">
          <h4>About Colombo</h4>
          <span>Colombo is the capital and largest city of Sri Lanka, and is located in the Western Province. 
            <p />
            The city is built on the delta where the Kelani River empties into the Indian ocean, and also encompasses a number of large lakes. 
            The Colombo metropolitan area has a population of 5.6 million people. </span>
        </div>),
        (<div className='layout-legend-hidden'></div>),
        "Colombo"
      ),
      new Stage(
        [[79.9336, 6.9813], [80.0609, 6.8980]],
        (<div className="layout-timeline-info layout-floating"><h4>Structures</h4>
        <span>Planet’s global building mapping <a href="https://www.planet.com/products/analytics/">product</a> isolates 
        structures from sattelite imagery, and can be used to unlock new insights about the region.</span></div>),
        (<div className='layout-legend-hidden'></div>),
        "Colombo - Structures"
      ),
      new Stage(
        [[79.9336, 6.9813], [80.0609, 6.8980]],
        (<div className="layout-timeline-info layout-floating"><h4>Flood frequency</h4>
        <span>Cloud to Street&apos;s historic flood frequency <a href="https://www.cloudtostreet.info/products">product</a>&nbsp;
        aggregates flood frequency data from the past 20 years, to identify where flooding occurs most often.</span></div>),
        (<div className='layout-legend-visible layout-timeline-legend layout-floating'>
          <div className="pl-ctrl-legend">
            <div className="pl-ctrl-legend-min">Low</div>
            <div className="pl-ctrl-legend-levels">
              <div className="pl-ctrl-legend-level" style={{'background-color': 'rgb(239, 243, 255)', 'width': '30px'}}></div>
              <div className="pl-ctrl-legend-level" style={{'background-color': 'rgb(189, 215, 231)', 'width': '30px'}}></div>
              <div className="pl-ctrl-legend-level" style={{'background-color': 'rgb(107, 174, 214)', 'width': '30px'}}></div>
              <div className="pl-ctrl-legend-level" style={{'background-color': 'rgb(33, 113, 181)', 'width': '30px'}}></div>
            </div>
            <div className="pl-ctrl-legend-max">High</div>
          </div>
        </div>),
        "Colombo - Flood Frequency"
      ),
      new Stage(
        [[79.96008, 6.95608], [80.01897, 6.91712]],
        (<div className="layout-timeline-info layout-floating"><h4>Structures at Risk of Flood</h4>
        <span>
          Combining these datasets allows us to visually and spatially identify buildings at risk from flooding.
          <p />
          From this, we can calculate that <b>2.0%</b> of the area in which floods have historically been observed in Colombo now contain structures.
        </span></div>),
        (<div className='layout-legend-visible layout-timeline-legend layout-floating'>
          <div className="pl-ctrl-legend">
            <div className="pl-ctrl-legend-min">Low</div>
            <div className="pl-ctrl-legend-levels">
              <div className="pl-ctrl-legend-level" style={{'background-color': 'rgb(254, 237, 222)', 'width': '30px'}}></div>
              <div className="pl-ctrl-legend-level" style={{'background-color': 'rgb(253, 190, 133)', 'width': '30px'}}></div>
              <div className="pl-ctrl-legend-level" style={{'background-color': 'rgb(253, 141, 60)', 'width': '30px'}}></div>
              <div className="pl-ctrl-legend-level" style={{'background-color': 'rgb(217, 71, 1)', 'width': '30px'}}></div>
            </div>
            <div className="pl-ctrl-legend-max">High</div>
          </div>
        </div>),
        "Colombo - Structures at risk of flood"
      )
    ]
  }
  getStages() {
    return this.stages;
  }
}